import { useEffect } from 'react';

import { Alerts } from '../components/Dashboard/Alerts';
import { Jobs } from '../components/Dashboard/Jobs';
import { Customers } from '../components/Dashboard/Customers';
import { Devices } from '../components/Dashboard/Devices';
import { Alert } from '../components/base/Alert';

import { usePageTitle } from '../contexts/PageTitleContext';
import { Button } from '../components/base/Button';
import { useNotification } from '../hooks/useNotifications';

export function DashboardPage() {
  const { setPageTitle } = usePageTitle();
  const addNotification = useNotification();

  useEffect(() => {
    setPageTitle('Dashboard');
  }, [setPageTitle]);

  return (
    <div className="w-full h-full grid gap-4 lg:grid-cols-2">
      <Button
        onClick={() =>
          addNotification(
            'success',
            'This is a test notification from DashboardPage.'
          )
        }
      >
        Test Button
      </Button>
      <Alerts />
      <Jobs />
      <Customers />
      <Devices />

      <div>
        <div className="space-y-4">
          <Alert
            severity="info"
            title="Information"
            message="This is an informational alert."
          />
          <Alert
            severity="success"
            title="Success"
            message="Operation completed successfully."
          />
          <Alert
            severity="warn"
            title="Warning"
            message="There may be issues to check."
          />
          <Alert
            severity="error"
            title="Error"
            message="An error occurred while processing."
          />
        </div>
      </div>
    </div>
  );
}
